export default __webpack_public_path__ + "static/media/back.53b6b4c8.jpg";